import { render, staticRenderFns } from "./NewDeliveryOrderCustomer.vue?vue&type=template&id=48249029&scoped=true&"
import script from "./NewDeliveryOrderCustomer.vue?vue&type=script&lang=js&"
export * from "./NewDeliveryOrderCustomer.vue?vue&type=script&lang=js&"
import style0 from "./NewDeliveryOrderCustomer.vue?vue&type=style&index=0&id=48249029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48249029",
  null
  
)

export default component.exports